module.exports = __webpack_public_path__ + "img/zanorari29.57f5968e.jpg";